import React from 'react';
import { ReactComponent as Logo } from '../images/cluster-logo.svg'
import styles from './NotFound.module.scss';
import { useSelector } from 'react-redux';
import { selectLoggedIn, selectChannels } from '../store/selectors/index';
import Link from 'redux-first-router-link';
import { ROUTE_ACTIONS } from '../store/routes';

export default function NotFound() {
  const loggedIn = useSelector(selectLoggedIn);
  const channels = useSelector(selectChannels);

  let contents: React.ReactNode[] = [<p>The page you requested could not be found.</p>];

  if (loggedIn) {
    contents.push(<p>Please choose a channel.</p>)
    contents.push(<ul>
      { channels.map(channel => <li key={channel.id}><Link to={{type: ROUTE_ACTIONS.CHANNEL, payload: {id: channel.id}}}>{ channel.name }</Link></li>)}
    </ul>)
  } else {
    contents.push(<p>Please <Link to={{type: ROUTE_ACTIONS.LOGIN}}>Login</Link> to access.</p>)
  }

  return (
    <div className={styles.notFound}>
      <Logo />

      <h1>Page not found</h1>

      { contents }
    </div>
  );
}